<template lang="pug">
div
    CrudForm(noButtons v-bind="staticData" :fields="myFields" :customRules="customRules" ref="mainForm" formTitle="Información Comercial:")
        div(slot="appendContent")
            h1.mt-4.mb-4 Oficinas:
            template(v-for="index in officeCounter")
                CrudForm(noButtons :fields="officeFields" noPadding :ref="'office' + index")
                div(style="display:flex; width: 100%; justify-content:center;" v-if="index === officeCounter.length - 1")
                    v-btn.font-weight-bold.display-1(:color="colors.danger" icon dark v-if="index != 0" @click="officeCounter.splice(-1,1)")
                        span(style="margin-top: -3px;") -            
                    v-btn.font-weight-bold.title(icon dark :color="colors.success" @click="officeCounter.push(officeCounter.length)") +
    v-layout(row)
        v-flex.xs12
            v-btn(block dark outline :color="colors.secondary" @click="clearAll()") limpiar formularios
        v-flex.xs12
            v-btn(block @click="sendAll()" dark :color="colors.secondary") Crear Proveedor
        
</template>

<script>
import { CrudForm, RUTInput } from '@/components/reusable_components'
import InputValidations from '@/mixins/InputValidations.js'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
import CommuneService from '@/services/api/commune/CommuneService'
import CustomerService from '@/services/api/provider/ProviderService'
import { mapActions } from 'vuex'
export default {
    name: 'provider-create',
    props: {},
    data: function() {
        return {
            formData: {},
            form: null,
            fields: [
                {
                    field: 'rut',
                    type: 'rut',
                    maxLength: 12,
                    value: '',
                    vuetifyProps: {
                        textFieldProps: {
                            label: 'RUT',
                        },
                    },
                },
                {
                    field: 'business_name',
                    type: 'text',
                    maxLength: 100,
                    value: '',
                    vuetifyProps: {
                        label: 'Razón social',
                    },
                    rules: ['required'],
                },
                {
                    field: 'alias_name',
                    type: 'text',
                    maxLength: 100,
                    value: '',
                    vuetifyProps: {
                        label: 'Nombre de Fantasía',
                    },
                    rules: ['required'],
                },
                {
                    field: 'is_pyme',
                    type: 'checkbox',
                    vuetifyProps: {
                        label: 'PYME',
                    },
                    value: true,
                },
            ],
            staticData: null,
            customRules: {
                minLength8: function(value) {
                    return value.length >= 8 ? true : 'El largo mínimo es 8'
                },
            },
            officeFields: [
                {
                    field: 'address',
                    type: 'text',
                    maxLength: 80,
                    value: '',
                    vuetifyProps: {
                        label: 'Dirección',
                    },
                    rules: ['required'],
                },
                {
                    field: 'phone',
                    type: 'text',
                    maxLength: 15,
                    value: ' ',
                    vuetifyProps: {
                        label: 'Fono',
                        'single-line': true,
                        mask: '+56#########',
                        'return-masked-value': true,
                    },
                },
                {
                    field: 'email',
                    type: 'text',
                    maxLength: 40,
                    value: '',
                    vuetifyProps: {
                        label: 'Correo electrónico',
                    },
                    rules: ['email'],
                },
                {
                    field: 'g_commune_id',
                    type: 'autocompleteObject',
                    value: 26,
                    vuetifyProps: {
                        label: 'Ciudad',
                    },
                    options: {
                        data: [],
                        text: 'name',
                        value: 'id',
                    },
                    rules: ['required'],
                },
            ],
            officeCounter: [0],
        }
    },
    computed: {
        myFields() {
            return this.fields
        },
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        async handleSubmit(data) {
            this.formData = data
            //
            let response = await CustomerService.createProvider(this.formData)
            //
            if (response.status == 'success') {
                let snackInfo = this.fillSnack(
                    'success',
                    'Éxito',
                    'El Proveedor fue creado exitosamente',
                    false,
                    3000
                )
                this.initSnackbar(snackInfo)
                this.$router.push({ path: `/providers/` })
            } else {
                //TODO: test response error from backend
                let snackInfo = this.fillSnack(
                    'error',
                    'Error',
                    response.error || response.message,
                    false,
                    3000
                )
                this.initSnackbar(snackInfo)
            }
        },
        // fillStaticFormData() {
        //     let information = {}
        //     information.toolbarTitle = 'Nuevo cliente'
        //     information.toolbarIcon = 'close'
        //     information.customRules = function(value) {
        //         return value.length >= 8 ? true : 'El largo mínimo es 8'
        //     }
        //     information.editable = false
        //     information.disabled = false
        //     information.submitText = 'Crear Cliente'

        //     return information
        // },
        async sendAll() {
            let validator = this.$refs.mainForm.$refs.form.validate()
            let officesInfo = []
            this.officeCounter.forEach(idx => {
                if (!this.$refs['office' + idx][0].$refs.form.validate())
                    validator = false
                this.$refs['office' + idx][0].vmodels.default_branch_office =
                    idx === 0
                officesInfo.push(this.$refs['office' + idx][0].vmodels)
            })
            if (!validator) return
            let commercialInfo = this.$refs.mainForm.vmodels
            commercialInfo.branch_offices = officesInfo
            await this.handleSubmit(commercialInfo)
        },
        clearAll() {
            this.officeCounter = [0]
            let aux = [...this.fields]
            this.fields = []
            this.fields = [...aux]
            aux = [...this.officeFields]
            this.officeFields = []
            this.officeFields = [...aux]
        },
    },
    watch: {},
    components: { CrudForm, RUTInput },
    mixins: [InputValidations, CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    beforeMount: async function() {
        //this.staticData = this.fillStaticFormData()
        let communes = await CommuneService.fetchCommunes()
        this.officeFields[3].options.data = communes

        // let arrPercentage = new Array(101)
        // for(var i=0; i < arrPercentage.length; i++){
        //     arrPercentage[i] = i
        // }
        // this.fields[8].options =arrPercentage
        // this.myFields = JSON.parse(JSON.stringify(this.fields))

        //this.percentageDiscount =
    },
    mounted: function() {
        this.setTitleTopBar('Nuevo proveedor')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_PURCHASE_PROVIDER')) ctx.$router.push('/')
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>